import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Eligibility270Component } from './eligibility270.component';

const routes: Routes = [
  {
    path: '',
    component: Eligibility270Component
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Eligibility270RoutingModule { }
